<template>
  <ContainerLR tag="section" class="publications">
    <div class="publications__container-left">
      <ContentL class="publications__info">
        <Title tag="h2" theme="outlined" class="is-centered">
          Publicaciones
        </Title>
        <p>
          Nuestro Programa de investigación viene generando diferentes proyectos
          y estudios, los cuales están publicados en diferentes revistas
          científicas nacionales e internacionales, accede a nuestra comunidad
          dentro del
          <a
            class="inverted publications__link"
            :href="program.community"
            target="_blank"
            >Repositorio Geofísico Nacional (REGEN)</a
          >
          para que puedas ver todas nuestras publicaciones.
        </p>
      </ContentL>
    </div>
    <div class="publications__container-right">
      <ContentR class="publications__last">
        <Title tag="h2" class="is-centered">Última Publicación</Title>
        <Suspense>
          <template #default>
            <LastPublicationWrapper :url="program.community" />
          </template>
          <template #fallback>
            <Loader />
          </template>
        </Suspense>
      </ContentR>
    </div>
  </ContainerLR>
</template>
<script>
import ContainerLR from "@/components/ui/objects/ContainerLR";
import ContentL from "@/components/ui/molecules/ContentL";
import ContentR from "@/components/ui/molecules/ContentR";
import Title from "@/components/ui/atoms/Title";
import Loader from "@/components/common/Loader";

import { defineAsyncComponent } from "vue";

export default {
  components: {
    ContainerLR,
    ContentL,
    ContentR,
    LastPublicationWrapper: defineAsyncComponent(() =>
      import("./LastPublicationWrapper")
    ),
    Title,
    Loader
  },
  props: {
    program: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/settings/_variables.scss";
.publications {
  &__container-left {
    padding: variables.$spacing-l 0;
    background-color: variables.$primary-color;
  }
  &__container-right {
    padding: variables.$spacing-l 0;
    background-color: variables.$background-lighter-color;
  }
  &__info {
    color: variables.$text-inverted-color;
  }
  &__link:hover {
    color: variables.$text-inverted-color;
  }
}
@media (min-width: 768px) {
  .publications {
    &__container {
      grid-gap: variables.$spacing-l;
    }
  }
}
</style>
